<template>
    <form
        class="form basic-form trip-form"
        autocomplete="off"
        novalidate
        @submit="emitSubmit"
    >
        <div class="form-field">
            <label for="topic">Topic:</label>
            <select id="topic" v-model="form.topic.value">
                <EnumOptions group="contact_topic" />
            </select>
            <FormError :errors="errors.topic" />
        </div>

        <div v-if="!isLoggedIn" class="form-field">
            <label for="email">Your email:</label>
            <input
                id="email"
                v-model="form.email.value"
                type="email"
                autocomplete="email"
            />
            <FormError :errors="errors.email" />
        </div>

        <div class="form-field">
            <label for="message">Message:</label>
            <textarea id="message" v-model="form.message.value" rows="6" />
            <FormError :errors="errors.message" />
        </div>

        <div class="form-buttons vertical">
            <TurnstileWidget
                v-if="!isLoggedIn"
                ref="turnstileWidget"
                class="form-widget"
                @verify="onVerify"
                @expire="onExpire"
            />
            <Bttn
                id="submit-contact"
                type="submit"
                :disabled="!isLoggedIn && form.token.value === ''"
                >Send</Bttn
            >
        </div>
    </form>
</template>

<script>
import BaseForm from "js/components/base/BaseForm.js";
import EnumOptions from "js/components/forms/EnumOptions";
import FormError from "js/components/forms/FormError";
import TurnstileWidget from "js/components/custom/TurnstileWidget";
import { useUserStore } from "js/stores/userStore";

export default {
    name: "ContactForm",
    components: {
        EnumOptions,
        FormError,
        TurnstileWidget,
    },
    extends: BaseForm,
    props: {
        initialTopic: {
            type: String,
            default: "other",
        },
    },
    data() {
        return {
            form: {
                topic: {
                    value: this.initialTopic,
                },
                email: {
                    value: "",
                    skip: () => this.isLoggedIn,
                },
                message: {
                    value: "",
                },
                token: {
                    value: "",
                    skip: () => this.isLoggedIn,
                },
            },
        };
    },
    computed: {
        isLoggedIn() {
            return useUserStore().isLoggedIn;
        },
    },
    methods: {
        onVerify(token) {
            this.form.token.value = token;
        },
        onExpire() {
            this.form.token.value = "";
        },
        resetCaptcha() {
            this.form.token.value = "";
            this.$refs.turnstileWidget?.reset();
        },
    },
};
</script>
